import { defineComponent as _defineComponent } from 'vue'
import {onActivated, onMounted, ref} from 'vue';
import userStoreModule from '@/store/modules/user';
import {getSupplyList, getListAdd, searchCategories, getIsFollow} from '@/api/miscellaneous';
import {useRouter, useRoute} from 'vue-router';
import moment from 'moment';
import {calcDistance, time2Stamp} from '@/libs/utils';
import {listSubscribe, turnPages} from '@/hooks';
import CityTreeSelector from '@/components/CityTreeSelector.vue';
import VarietiesTreeSelector from '@/components/VarietiesTreeSelector.vue';
import Specifications from './Specifications.vue';
import ListItemAd from '@/components/ListItemAd.vue';
import SearchCategorie from '@/components/SearchCategorie.vue';
import VipTag from '@/components/VipTag.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupplyList',
  setup(__props, { expose }) {
  expose();

const {subscribe, isSubscribe} = listSubscribe();

const router = useRouter();
const route = useRoute();
const comprehensive = [
    {text: '综合', value: ''},
    {text: '距离', value: 'distance'},
    {text: '时间', value: 'time'},
    {text: '等级', value: 'rank'},
    {text: '价格', value: 'price'},
    {text: '清货', value: 1},
    {text: '精品', value: 2},
];
const comprehensiveValue = ref('');
const areaMenu = ref<any>(null);
const categoryMenu = ref<any>(null);
const getListData = ref<any>({
    lat: userStoreModule.userDetail.location?.lat || 0,
    lon: userStoreModule.userDetail.location?.lon || 0,
    keyword: route.query.keyword || '',
    areaId: '',
    categoryId: '',
    sort: '',
    quality: '',
    specifications: '',
});
const addList = ref<any[]>([]);

const isShowSearch = ref(false);

const isNotFollow = ref(false);

const filterCategoryName = ref('全部');

const showregister = ref(false);
const close = () => {
    showregister.value = false;
};

const {
    list,
    loading,
    finished,
    refresh,
    loadMore: getList,
} = turnPages({
    api: getSupplyList,
    params: getListData,
    loadingReturn: true,
});

onMounted(() => {
    const {categoryId, categoryName, keyword, page} = route.query;
    if (categoryId) {
        getListData.value.categoryId = categoryId as string;
        getListData.value.keyword = (keyword as string) || '';
        filterCategoryName.value = categoryName as string;
    }
    getAdd();
    let stotal = userStoreModule.userDetail?.totalSupplies || 0;
    let a = Number(page) || 1;
    if (stotal == 0 && a >= 1) {
        showregister.value = true;
    }
    isFollow();
    console.log(showregister, page, '--user');
});

onActivated(() => {
    const {categoryId, categoryName, keyword} = route.query;
    getListData.value.keyword = (keyword as string) || '';
    if (categoryId) {
        list.value = [];
        getListData.value.categoryId = (categoryId as string) || '';
        filterCategoryName.value = categoryName as string;
        getAdd();
        refresh();
    }
    router.replace({name: 'SupplyList', query: {}});
});

const search = () => {
    refresh();
};
const setAreaId = (id: string) => {
    refresh({areaId: id});
    areaMenu.value.toggle();
};

const setCategoryId = (id: string, name: string) => {
    filterCategoryName.value = name;
    refresh({categoryId: id});
    categoryMenu.value.toggle(false);
};

const setSort = (value: string | number) => {
    if (value === 1 || value === 2) {
        refresh({quality: value, sort: ''});
    } else {
        refresh({quality: '', sort: value});
    }
};

const confirmSpecifications = (data: any) => {
    getListData.value.specifications = data.length ? JSON.stringify(data) : '';
    refresh();
};

const getAdd = () => {
    getListAdd({keywords: '广告位用勿动处理求购供应列表中'}).then((res: any) => {
        addList.value = JSON.parse(res.contentJson);
        getList();
    });
};

const timeToNow = (time: number) => {
    let cycle = 60 * 1000 * 60 * 24 * 7;
    let ttt = (new Date().getTime() - time) % cycle;
    return moment(new Date().getTime() - ttt).fromNow();
};

const searchList = (data: any) => {
    if (!data.name) {
        data.name = data.categoryName;
    }
    filterCategoryName.value = data.categoryName;
    isShowSearch.value = false;
    refresh({keyword: data?.name});
};

const distance = (point: {lat: number; lon: number}) => {
    if (userStoreModule.userDetail.location) {
        let {lat, lon} = userStoreModule.userDetail.location;
        const dis = calcDistance({lat: point.lat, lng: point.lon}, {lat, lng: lon});
        return dis > 1000 ? (dis / 1000).toFixed(2) + 'km' : dis.toFixed(2) + 'm';
    } else {
        return '';
    }
};
const isFollow = () => {
    const userId = userStoreModule.userDetail.user.id;
    getIsFollow(userId).then((res: any) => {
        isNotFollow.value = !res.subscripte;
    });
};

const reset = () => {
    getListData.value.keyword = '';
    getListData.value.categoryId = '';
    searchList({name: ''});
};

const __returned__ = { subscribe, isSubscribe, router, route, comprehensive, comprehensiveValue, areaMenu, categoryMenu, getListData, addList, isShowSearch, isNotFollow, filterCategoryName, showregister, close, list, loading, finished, refresh, getList, search, setAreaId, setCategoryId, setSort, confirmSpecifications, getAdd, timeToNow, searchList, distance, isFollow, reset, onActivated, onMounted, ref, userStoreModule, getSupplyList, getListAdd, searchCategories, getIsFollow, useRouter, useRoute, moment, calcDistance, time2Stamp, listSubscribe, turnPages, CityTreeSelector, VarietiesTreeSelector, Specifications, ListItemAd, SearchCategorie, VipTag }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})